import MobileService from './MobileService'
import PrintService from "./PrintService"

export default {
       
    MobileService: new MobileService(),
    PrintService: new PrintService()
}